import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
    return (
        <section className="hero" id="home">
            <div className="hero-media" aria-hidden="true">
                <img src="/logo/l1.jpeg" alt="" />
                <div className="hero-signal hero-signal--one"></div>
                <div className="hero-signal hero-signal--two"></div>
            </div>

            <div className="container hero-container">
                <div className="hero-content fade-in">
                    <p className="eyebrow">Enterprise AI Advisory</p>
                    <h1>AI Consulting South Africa</h1>
                    <p className="hero-subtitle">
                        Strategy, machine learning, and automation systems for African enterprises that need measurable advantage, not experiments without ownership.
                    </p>
                    <div className="hero-cta">
                        <Link className="btn-primary" to="/readiness">Check AI Readiness</Link>
                        <Link className="btn-secondary" to="/services">Explore Solutions</Link>
                    </div>
                    <dl className="hero-proof" aria-label="Consulting proof points">
                        <div>
                            <dt>8 weeks</dt>
                            <dd>to an executive AI roadmap</dd>
                        </div>
                        <div>
                            <dt>POPIA</dt>
                            <dd>aware data governance</dd>
                        </div>
                        <div>
                            <dt>MLOps</dt>
                            <dd>ready for production teams</dd>
                        </div>
                    </dl>
                </div>
            </div>
        </section>
    );
};

export default Hero;
